// // 对数据进行映射，通过state的不同值返回一个新的值
// export const singer = state => state.singer
export const courseId = state => state.courseId
export const userId = state => state.userId
export const studyExperience = state => state.studyExperience
export const workExperience = state => state.workExperience
export const user = state => state.user
export const courseIdList = state => state.courseIdList
export const recommendCourse = state => state.recommendCourse
export const commuId = state => state.consultation.commuId
export const commuShowFlag = state => state.consultation.commuShowFlag
export const storeCourseLists = state => state.courseClassify.storeCourseLists
export const storeCourseSeconds = state => state.courseClassify.storeCourseSeconds
export const storeOrganLists = state => state.organClassify.storeOrganLists
export const storeCerts = state => state.userCenter.storeCerts
export const currentData = state => state.currentData
export const searchMark = state => state.searchMark


// WEBPACK FOOTER //
// ./src/store/getters.js